import React from "react";
import GaugeChart from "react-gauge-chart";
import { Card, Button } from "react-bootstrap";

const formatText = (value) => {
  return value;
};
const Gauge = ({
  title = "pH Sensor",
  description = "Determines the current pH value",
  className,
  noOfLevels = 14,
  positionOfNeedle = 0.5,
  variant = "success",
  deviceStatus = "Normal",
  unit = "ppm",
  sensorText = "abc",
  sensorValue = 1000,
}) => {
  return (
    <Card className={className} style={{ width: "25rem" }}>
      <GaugeChart
        id="gauge-chart2"
        nrOfLevels={noOfLevels}
        percent={positionOfNeedle}
        arcWidth={0.3}
        textColor="#000000"
        // hideText="true"
        formatTextValue={formatText}
      />
      <Card.Body>
        <Card.Title>{title}</Card.Title>
        <Card.Text>{description}</Card.Text>
        <Card.Subtitle className="py-1">
          <p>
            {sensorText} = {sensorValue} {unit}{" "}
          </p>
        </Card.Subtitle>
        <Button variant={variant}>{deviceStatus}</Button>
      </Card.Body>
    </Card>
  );
};

export default Gauge;
